import React from "react";
import {observer} from "mobx-react";
import {IconButton, Button, Modal, Stack, Typography} from "@mui/material";
import styled from "@emotion/styled";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import CloseIcon from "@mui/icons-material/Close";
import {Exist} from "views/components/exist/exist.component";
import type {IModalConfirmController} from "views/components/modals/modal_confirm/modal_confirm.controller";
import logo from "assets/img/logo.svg";

const ModalContent = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 16px;
	outline: none;
	max-width: 600px;
	width: 100%;
	background: var(--modalBackground);
	padding: 16px 20px 32px;
	border-radius: 4px;
	text-align: center;
	color: #ffffff;
	@media screen and (max-width: 640px) {
		max-width: unset;
		left: 24px;
		right: 24px;
		width: auto;
		transform: translateY(-50%);
	}

	button {
		max-width: 300px;
	}
`;

const CloseBlock = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	button {
		padding: 0;

		svg {
			width: 32px;
			height: 32px;
			color: #fff;
		}
	}
`;

const Icon = styled.div``;

const StyledButton = styled(Button)`
	width: 100%;
`;

const Buttons = styled(Stack)`
	gap: 12px;
	justify-content: center;
	align-items: center;
	width: 100%;
`;

export const ModalConfirm: React.FC = observer(() => {
	const {isOpen, modalContent, i18n, close} = useViewController<IModalConfirmController>(
		Bindings.ModalConfirmController
	);

	return (
		<Modal open={isOpen}>
			<ModalContent>
				<CloseBlock>
					<IconButton sx={{minWidth: 0}} onClick={close}>
						<CloseIcon color={"inherit"} />
					</IconButton>
				</CloseBlock>
				<Icon>
					<img src={logo} alt="Header Logo" />
				</Icon>
				<Typography variant={"h4"}>
					{modalContent?.title || i18n.t("modal.confirm.title", "Confirm")}
				</Typography>
				<Exist when={modalContent?.message}>
					<Typography>{modalContent?.message}</Typography>
				</Exist>
				<Buttons>
					<StyledButton fullWidth variant="contained" color={"secondary"} onClick={close}>
						{i18n.t("modal.confirm.cancel_button", "Cancel")}
					</StyledButton>
					<Exist when={modalContent?.callback}>
						<StyledButton
							fullWidth
							variant="contained"
							onClick={modalContent?.callback}>
							{i18n.t("modal.confirm.confirm_button", "Confirm")}
						</StyledButton>
					</Exist>
				</Buttons>
			</ModalContent>
		</Modal>
	);
});
